import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartDevicesService } from '@app/modules/smart-devices/service/smart-devices.service';
import { BillingFacade, MANAGED_SMART_DEVICES_FEATURES } from '@app/shared/+state/billing';
import { LoadingState, NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { map, tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-manage-device-addon',
  templateUrl: './manage-device-addon.component.html',
  styleUrls: ['./manage-device-addon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageDeviceAddonComponent implements OnInit {
  public confirmDeviceAddon = new UntypedFormControl(false, { validators: [Validators.requiredTrue] });
  public submitting$ = this.billingFacade.deviceAddOnState$.pipe(
    tap(({ submitting }) => this.leaveWizardOnSuccess(submitting)),
    map((change) => change.submitting === LoadingState.Pending || change.submitting === LoadingState.Success)
  );
  public smartDevicePrice$ = this.billingFacade.smartDevicePrice$;
  public features = MANAGED_SMART_DEVICES_FEATURES;

  constructor(
    private readonly billingFacade: BillingFacade,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly smartService: SmartDevicesService,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit(): void {
    this.billingFacade.loadSubscription();
  }

  public leaveWizard(): void {
    const closeLink = this.route.snapshot.queryParamMap.get('closeLink') ?? '/settings/your-plan';
    this.router.navigate([closeLink]);
  }

  public activateDeviceAddon(): void {
    this.billingFacade.confirmDeviceAddon();
  }

  private leaveWizardOnSuccess(submitting: LoadingState) {
    if (submitting === LoadingState.Success) {
      if (!this.route.snapshot.queryParamMap.get('closeLink')?.includes('devices')) {
        this.leaveWizard();
        return;
      }

      // open up connect modal
      this.smartService.connectDeviceAccount().subscribe((connectionUrl) => {
        if (!connectionUrl) {
          this.toast.open('Unable to connect a device account at this time', 'OK', NotificationType.Error);
          return;
        }

        window.location.href = connectionUrl;
      });
    }
  }
}
